export default __webpack_public_path__ + "static/media/gallery-6.0ce88551.jpg";